import { AnimationWithSize } from './AnimationWithSize';

export const Whiteboard = () => (
	<AnimationWithSize src="https://dam-cdn.atl.orangelogic.com/AssetLink/j2os26c533drhayq0qx6e705h5vh328b.riv" />
);
